import RealEstateQuestions from '../../../../../components/Forms/Constants/TCFD/RealEstate/RealEstateQuestions';
import {inputType} from '../../../interface/inputType';

export const RealEstateGovernanceTabQuestions = [
  {
    key: RealEstateQuestions.QUESTION_GROUP_1.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_1.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_1.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_2.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_2.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_2.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const RealEstateStrategyTabQuestions = [
  {
    key: RealEstateQuestions.QUESTION_GROUP_3.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_3.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_3.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_4.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_4.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_4.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_5.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_5.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_5.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const RealEstateRiskManagementTabQuestions = [
  {
    key: RealEstateQuestions.QUESTION_GROUP_6.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_6.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_6.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_7.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_7.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_7.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_8.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_8.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_8.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  }
];

export const RealEstateMetricsTargetsTabQuestions = [
  {
    key: RealEstateQuestions.QUESTION_GROUP_9.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_9.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_9.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_10.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_10.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_10.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  },
  {
    key: RealEstateQuestions.QUESTION_GROUP_11.KEY,
    label: RealEstateQuestions.QUESTION_GROUP_11.NAME,
    kpiId: '',
    items: [
      {
        question: '',
        field: [
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_1_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_2_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true,
            options:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3.options
          },
          {
            fieldType:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3_COMMENT
                .fieldType,
            fieldName:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3_COMMENT
                .fieldName,
            fieldLabel:
              RealEstateQuestions.QUESTION_GROUP_11.QUESTIONS.QUESTION_3_COMMENT
                .fieldLabel,
            heading: inputType.HEADING,
            colSpan: true
          }
        ]
      }
    ]
  }
];
